import {inject, RESPONSE_INIT} from '@angular/core';
import {type ResolveFn, Router} from '@angular/router';
import {redirectTo404} from '@app/navigation/page-not-found/page-not-found.component';
import {CommonsSearchProject} from '@models/commons-types';
import {mapSearchProjectToBaseModel, ProjectPageData} from '@project/project-base.model';
import {SearchService} from '@services/search/search.service';
import {catchError, from, of} from 'rxjs';
import {map} from 'rxjs/operators';

export const publicProjectResolver: ResolveFn<ProjectPageData> = route => {
  const searchService = inject(SearchService);
  const router = inject(Router);
  const response = inject(RESPONSE_INIT, {optional: true});

  const projectID = route.paramMap.get('projectId');
  if (!projectID) {
    return redirectTo404(router, response);
  }

  return from(searchService.loadProjectDetails(projectID)).pipe(
    map(projectData => {
      if (projectData.project?.scheduled_for_deletion_on) {
        return redirectTo404(router, response);
      }

      return {
        project: mapSearchProjectToBaseModel(projectData.project as CommonsSearchProject),
        datasetTiles: projectData.datasetTiles,
        resourceTiles: projectData.resourceTiles,
      };
    }),
    catchError(err => {
      console.error('publicProjectResolver error:', err);
      return of(redirectTo404(router, response));
    }),
  );
};
